var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 66,
    viewBox: "0 0 86 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1262_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.77601 9.71874L1.92845 56.6153L1.93135 57.523C1.94437 61.5334 5.20597 64.7739 9.21633 64.7609L76.9895 64.5405C80.9998 64.5275 84.2403 61.2659 84.2273 57.2555L84.069 8.5436C84.0559 4.53324 80.7943 1.29277 76.784 1.3058L9.01086 1.52607C5.0005 1.53909 1.76002 4.80068 1.77305 8.81105L1.77601 9.71874Z",
    fill: "url(#paint0_linear_1262_60)",
    stroke: "#8D731D",
    strokeWidth: 0.60512
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2158 1.75005C29.9188 11.3419 25.3439 37.3569 33.4204 64.6823",
    stroke: "#8D731D",
    strokeWidth: 0.60512
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.791 1.68335C57.1504 11.2535 61.8943 37.2383 53.9956 64.6155",
    stroke: "#8D731D",
    strokeWidth: 0.60512
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.12359 23.6356L29.3539 23.5472",
    stroke: "#8D731D",
    strokeWidth: 0.60512
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0964 23.1514L84.1164 23.0668",
    stroke: "#8D731D",
    strokeWidth: 0.60512
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18218 41.789L29.4124 41.7005",
    stroke: "#8D731D",
    strokeWidth: 0.60512
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.155 41.305L84.1749 41.2203",
    stroke: "#8D731D",
    strokeWidth: 0.60512
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1262_60",
    x1: 83.0554,
    y1: 1.36794,
    x2: 2.17738,
    y2: 65.5172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495738,
    stopColor: "#FEE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7BD61"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1262_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.5bfc3775b8921658bf618a4d2951cb34.svg";
export { ForwardRef as ReactComponent };